define(["require", "exports", "jquery", "../context"], function (require, exports, $, context_1) {
    "use strict";
    exports.__esModule = true;
    function tabs($sel) {
        var $header = $sel.find('>ul:first-child');
        $header.find('> li:first-child').toggleClass('active', true);
        $sel.find('>div:first-of-type').toggleClass('active', true);
        $header.find('a').click(function (e) {
            e.preventDefault();
            var $tab = $(e.currentTarget).closest('li');
            var $activeTab = $header.find('.active');
            var prevIndex = $activeTab.index();
            var targetIndex = $tab.index();
            if (prevIndex != targetIndex) {
                $activeTab.toggleClass('active', false);
                $tab.toggleClass('active', true);
                var $tabs = $header.parent().find('>div');
                $($tabs[prevIndex]).toggleClass('active', false);
                $($tabs[targetIndex]).toggleClass('active', true);
            }
        });
        return $sel;
    }
    function showDialog($dlg, option) {
        var $closer = $dlg.find('.closer');
        var $viewport = $('meta[name="viewport"]');
        if (!$closer.length) {
            $closer = $('<div class="closer"></div>').prependTo($dlg);
            $dlg.click(function (e) {
                e.stopPropagation();
            });
            $closer = $dlg.find('.closer, .continue');
            $closer.click(function (e) {
                e.preventDefault();
                $dlg.dialog('close');
            });
        }
        var $curDlg = $('.ui-widget-overlay > *');
        if ($curDlg.length) {
            return;
        }
        $dlg.wrap('<div class="ui-widget-overlay"></div>');
        $('.ui-widget-overlay').click(function (e) {
            $dlg.dialog('close');
        });
        $('body').toggleClass('noscroll', true);
        if ($dlg.hasClass('lock-zoom') && context_1["default"].isMobile()) {
            $viewport.attr('content', 'width=device-width, user-scalable=no');
        }
        $dlg.show();
        return $dlg;
    }
    function closeDialog($dlg, option) {
        $('body').toggleClass('noscroll', false);
        var $viewport = $('meta[name="viewport"]');
        if ($dlg.hasClass('lock-zoom') && context_1["default"].isMobile()) {
            $viewport.attr('content', 'width=480');
        }
        if ($dlg.parent().hasClass('ui-widget-overlay')) {
            $dlg.hide();
            var url = $dlg.data('onCloseNavigate');
            if (url) {
                window.location.href = url;
            }
            $dlg.unwrap();
            return $dlg;
        }
        else {
            $('.master-wrapper-content').toggleClass("blur", false);
            return $dlg.remove();
        }
    }
    function isCurrentDialog($dlg) {
        return $dlg.is(":visible") && $dlg.closest('.ui-widget-overlay').length > 0;
    }
    function dialog($sel, methodOrOption) {
        if (methodOrOption === "show") {
            return showDialog($sel);
        }
        else if (methodOrOption === "close") {
            return closeDialog($sel);
        }
        else if (methodOrOption === "current") {
            return isCurrentDialog($sel);
        }
        else if ($.isPlainObject(methodOrOption)) {
            return showDialog($sel, methodOrOption);
        }
        else {
            $.error("Method " + methodOrOption + " doesn't exist");
        }
    }
    (function ($) {
        $.fn.tabs = function () { return tabs(this); };
        $.fn.buttonset = function () { return this; };
        $.fn.button = function () { return this; };
        $.fn.dialog = function (action) { return dialog(this, action); };
    })($);
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/jquery-ui-stubs.js
// module id = 18
// module chunks = 0